import React, { useEffect, useState } from 'react'
import Playlist from './Playlist'
import Loader from '../loader/Loader'

import { useSpotify } from '../../hoc/context/SpotifyContextContainer'
import { GetPlayer } from '../../hoc/Layout/Layout'
import { makeSpotifyRequest, makeSpotifyPostRequest, makeSpotifyDeleteRequest } from '../../config/SpotifyRequests'

import Error from '../../widgets/error/Error'

export default function PlaylistContainer(props) {
    const { accessToken, user } = useSpotify() 
    const { modal, setModal } = GetPlayer()
    const id = props.match.params.id

    const [ render, setRender ] = useState(false)
    const [ data, setData ] = useState(null)

    const removeFromList = async (item) => {
        try {
            const data = {
                "tracks": [{
                    "uri": item.uri
                }]
            }
            const dd = (await makeSpotifyDeleteRequest(`https://api.spotify.com/v1/playlists/${id}/tracks`, data, accessToken))
            setModal(null)
        } catch(e){
             setModal(<Error message={`An error has occured : Could not remove item!!!`} />)
        }
    }

    useEffect(async () => {

        try {
        //Retrieve Playlist cover image
            const playlist = (await makeSpotifyRequest(`https://api.spotify.com/v1/playlists/${id}`, accessToken)).data
            const image = playlist.images[0].url 

            const tracksLink = playlist.tracks.href
            const tracks = (await makeSpotifyRequest(`${tracksLink}`, accessToken)).data.items

            const owned = user.id === playlist.owner.id
            setData({
                playlist,
                image,
                tracks,
                owned
            })
            setRender(true)
        } catch(e){
            //Error Handeling Here
            setModal(<Error message={`Sorry !! playlist does not contain any tracks. check out the discover page and add tracks to your playlist.`} />)
            props.history.push('/discover');
        }     


    }, [props.match.params.id, modal])
    return (
        <>
            { data && <Playlist remove={removeFromList} {...data}/>}
            { !data && <Loader /> }
        </>
    )
}
